import { Tabs } from '@inflearn/ds-react-next';
import { find } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';

const POLICY_CATEGORY = [
  { title: '이용약관', href: '/policy/partners-terms' },
  { title: '운영 정책', href: '/policy/partners-operation' },
  { title: '가이드', href: '/policy/partners-guide' },
] as const;

export const PartnersPolicyTabs = () => {
  const { t } = useTranslation();
  const router = useRouter();

  const getActiveTabValue = () => {
    if (router.pathname.includes('/partners-terms')) {
      return find(POLICY_CATEGORY, { title: '이용약관' })?.href;
    }

    if (router.pathname.includes('/previous-partners-terms')) {
      return find(POLICY_CATEGORY, { title: '이용약관' })?.href;
    }

    if (router.pathname.includes('/partners-operation')) {
      return find(POLICY_CATEGORY, { title: '운영 정책' })?.href;
    }

    if (router.pathname.includes('/partners-guide')) {
      return find(POLICY_CATEGORY, { title: '가이드' })?.href;
    }

    return router.pathname;
  };

  return (
    <Tabs value={getActiveTabValue()} w="100%" pt={32} wrap="nowrap">
      <Tabs.List w="100%">
        {POLICY_CATEGORY.map((category) => (
          <Link key={category.href} href={category.href}>
            <Tabs.Tab value={category.href}>{t(category.title)}</Tabs.Tab>
          </Link>
        ))}
      </Tabs.List>
    </Tabs>
  );
};
